import { Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

function SettingsSenders() {
    return (
        <div className="marketing-settings__senders">
            <div className="marketing-settings__senders__header">
                <Text type="h5" bold>
                    {getLiteral('label_marketing_campaigns_senders')}
                </Text>
            </div>
        </div>
    );
}

SettingsSenders.displayName = 'SettingsSenders';

export default SettingsSenders;
